import {
  BoxSpg,
  GridContainer,
  GridItem,
  THUNK_STATUS,
  TableSkeleton,
  AlertSpg,
  TableButton,
} from "@duosoftbg/nacid-components";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import useAppSelector from "../../../../../../../hooks/redux/base/useAppSelector";
import { filterArUniEntryRequests } from "../../../../../../../store/redux/slice/Request/arUniEntryRequests";
import ARUniEntryRequestListTable from "../../../../request/arUni/list/ARUniEntryRequestListTable";
import useAppDispatch from "../../../../../../../hooks/redux/base/useAppDispatch";

const ARUniEntryRequestAdminList = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const arUniEntryRequestFilter = useAppSelector((state) => {
    return state.Request.arUniEntryRequestFilter;
  });

  const arUniEntryRequests = useAppSelector((state) => {
    return state.Request.arUniEntryRequests;
  });

  useEffect(() => {
    dispatch(filterArUniEntryRequests(arUniEntryRequestFilter));
  }, [dispatch, arUniEntryRequestFilter]);

  const createOptions = (record) => {
    return (
      <TableButton
        type={"view"}
        title={t("l.btn.view")}
        to={"/admin-console/ar-uni-entry-request/view?id=" + record.id}
      />
    );
  };

  return (
    <BoxSpg>
      <GridContainer mt={0}>
        <GridItem sm={12} md={12} pr={0}>
          {(arUniEntryRequests.list.status === THUNK_STATUS.PENDING ||
            arUniEntryRequests.list.status === THUNK_STATUS.INITIAL) && <TableSkeleton />}
          {arUniEntryRequests.list.status === THUNK_STATUS.REJECTED && (
            <AlertSpg severity={"error"}>{t("m.generic.error.service.fail")}</AlertSpg>
          )}
          {arUniEntryRequests.list.status === THUNK_STATUS.FULFILLED && (
            <ARUniEntryRequestListTable createOptions={createOptions} />
          )}
        </GridItem>
      </GridContainer>
    </BoxSpg>
  );
};
export default ARUniEntryRequestAdminList;
